<template>
  <div class="main-content">
    <div class="card main_price_block">
      <div class="card-body">
        <p>Поиск цены на сайте Mediately</p>
        <SearchPrice/>
      </div>
    </div>
  </div>
</template>
<script>
import SearchPrice from "@/views/nomenclature/components/drugOrder/SearchPrice.vue";

export default {
  components: {
    SearchPrice,
  }
}
</script>

<style scoped>
.main_price_block {
  background-color: #eeeded;
}
</style>
